import styled from 'styled-components'
import theme from '../../../../styles/theme'

const WHITE_COLOR = 'white'

export const Container = styled.div`
  position: relative;
  margin-left: 8;
  height: 36px;
  width: 90px;
  z-index: 2;
`

export const DropDown = styled.div`
  position: absolute;
  user-select: none;
`

export const PlaceHolder = styled.div`
  color: ${props => props.color};
  font-family: ${theme.bodyFontFamily};
  font-size: 15px;
`

export const UnorderedList = styled.ul`
  list-style: none;
  display: ${props => (props.isSelectorOpened ? 'block' : 'none')};
  border: 1px solid ${props => props.color};
  background-color: ${props =>
    props.color === WHITE_COLOR ? theme.black : theme.white};
  margin-top: -1px;
  padding: 0;
`

export const ListItem = styled.li`
  font-family: ${theme.bodyFontFamily};
  font-size: 15px;
  line-height: 2rem;
  padding: 0 0.4rem 0 0.7rem;
  color: ${props => props.color};
  border-bottom: 1px solid ${props => props.color};
  cursor: pointer;
  transition: ${theme.transitionDefault};

  &:hover {
    background-color: ${props =>
    props.color === WHITE_COLOR ? theme.grayDark : theme.grayLight};
  }

  &:last-child {
    border-bottom: 0;
  }
`

export const Select = styled.div`
  cursor: pointer;
  height: 34px;
  width: 73px;
  background: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${props => props.color};
  color: ${props => props.color};
  padding: 0 0.4rem 0 0.7rem;
`

export const ListItemMobile = styled.div`
  display: inline-block;
  color: ${props => props.color};
  font-size: 20px;
  cursor: pointer;

  &:after {
    display: inline-block;
    content: '/';
    margin: 0 6px;
    color: ${theme.black};
  }

  &:last-of-type {
    &:after {
      display: none;
    }
  }
`
